export default __webpack_public_path__ + "static/media/scratch7.c076a047.mp3";